module.exports = __webpack_public_path__ + "img/clockwise.e2bee4ad.svg";